export function getLongDate(date){
  date=date||new Date()
  const monthText = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return `${monthText[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
}
